module.exports = __webpack_public_path__ + "img/szafka.5f91e6a6.png";